document.addEventListener('DOMContentLoaded', function() {
  // Ensure the script runs after the entire page is fully loaded
  window.addEventListener('load', function() {
    const contactForm = document.getElementById('ContactForm');
    const formResponse = document.getElementById('form-response');

    if (contactForm) {
      contactForm.addEventListener('submit', function(event) {
        event.preventDefault();

        const formData = new FormData(contactForm);

        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: {
            'Accept': 'application/json'
          }
        })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok.');
        })
        .then(data => {
          formResponse.style.display = 'block';
          if (data.status === 'success') {
            formResponse.style.color = 'green';
            formResponse.innerHTML = 'Thank you for your message. We will get back to you soon.';
            contactForm.reset();
          } else {
            formResponse.style.color = 'red';
            formResponse.innerHTML = 'There was an error. Please try again.';
          }
        })
        .catch(error => {
          formResponse.style.display = 'block';
          formResponse.style.color = 'red';
          formResponse.innerHTML = 'There was an error. Please try again.';
        });
      });
    }
  });
});